import DuplicateTemplateMessage from "@features/ux/components/shared/components/duplicateMessage";
import SendCommunication from "@features/ux/components/shared/components/sendCommuication";
import { TemplatePreviewDialog } from "@features/ux/components/shared/components/templatePreviewDialog";
import { Button } from "@shared/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle } from "@shared/ui/dialog";
import { Copy, Mail, Plus, Send, SquarePenIcon, CheckCircle, XCircle } from "lucide-react";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateTemplateStatus } from "../../hooks";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

const QuickAction = ({ templateData }) => {
  const { id, name } = useParams();
  const navigate = useNavigate();
  const [openSendCommunication, setOpenSendCommunication] = useState(false);
  const [openDuplicateTemplateMessage, setOpenDuplicateTemplateMessage] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [openConfirmStatus, setOpenConfirmStatus] = useState(false);

  const { mutate: updateTemplateStatus } = useUpdateTemplateStatus(id);

  const isActive = templateData?.statusDisplay === "Active";

  const handleToggleStatus = () => {

    const statusValue = isActive ? 1 : 0;

    updateTemplateStatus(
      {
        remote_utility_id: getRemoteUtilityId(),
        status: statusValue, 
      },
      {
        onSuccess: () => {
          setOpenConfirmStatus(false);
        },
      }
    );
  };

  return (
    <div>
      <div>
        <h2 className="text-md font-semibold">Quick Actions</h2>
      </div>

      <div className="flex flex-col gap-2 mt-4">
        <Button variant="default" onClick={() => setOpenSendCommunication(true)}>
          <Send className="mr-2 h-4 w-4" /> Send Communication
        </Button>

        <Button
          variant="outline"
          onClick={() => navigate("/communication-hub/workflows/create")}
        >
          <Plus className="mr-2 h-4 w-4" /> Create Workflow
        </Button>

        <Button
          variant="outline"
          onClick={() =>
            navigate(
              `/communication-hub/templates/edit/${id}/${encodeURIComponent(name || "")}`
            )
          }
        >
          <SquarePenIcon className="mr-2 h-4 w-4" /> Edit Template
        </Button>

        <Button variant="outline" onClick={() => setOpenDuplicateTemplateMessage(true)}>
          <Copy className="mr-2 h-4 w-4" /> Duplicate Template
        </Button>

        <Button variant="outline" onClick={() => setOpenPreview(true)}>
          <Mail className="mr-2 h-4 w-4" /> Preview
        </Button>

        {/* TOGGLE STATUS BUTTON */}
        <Button
          variant="outline"
          onClick={() => setOpenConfirmStatus(true)}
        >
          {isActive ? (
            <>
              <XCircle className="mr-2 h-4 w-4" /> Mark as Inactive
            </>
          ) : (
            <>
              <CheckCircle className="mr-2 h-4 w-4" /> Mark as Active
            </>
          )}
        </Button>
      </div>

      {/* SEND COMMUNICATION */}
      <SendCommunication
        open={openSendCommunication}
        onOpenChange={setOpenSendCommunication}
        source="template"
        templateName={name}
        onSend={() => {}}
      />

      {/* DUPLICATE */}
      <DuplicateTemplateMessage
        open={openDuplicateTemplateMessage}
        onOpenChange={setOpenDuplicateTemplateMessage}
        actiontype="template"
        templateName={name || ""}
        templateId={id}
        onDuplicate={() => {}}
      />

      {/* PREVIEW */}
      <TemplatePreviewDialog
        open={openPreview}
        onOpenChange={setOpenPreview}
        templateData={templateData}
      />

      {/* CONFIRM STATUS */}
      <Dialog open={openConfirmStatus} onOpenChange={setOpenConfirmStatus}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle>
              {isActive ? "Mark as Inactive?" : "Mark as Active?"}
            </DialogTitle>
          </DialogHeader>

          <p className="text-sm text-muted-foreground">
            Are you sure you want to{" "}
            <strong>{isActive ? "deactivate" : "activate"}</strong> this template?
          </p>

          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setOpenConfirmStatus(false)} >
              Cancel
            </Button>

            <Button onClick={handleToggleStatus} >
          Yes, Continue
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default QuickAction;
